import React from "react";

const ListItem = ({ payment, handleDeleteCard, setDefaultPayment }) =>
  (payment && (
    <li>
      <a
        href="javascript:void(0)"
        className="d-flex justify-content-between align-items-center"
      >
        <div
          className="d-flex justify-content-between align-items-center flex-grow-1"
          onClick={() => setDefaultPayment(payment.uid)}
        >
          <div className="d-flex align-items-center flex-grow-1">
            <div className="card-image"><img src={`/svg/payment/${payment.method.toLowerCase()}.svg`} /></div>
            <p className="card-number">{`**** **** **** ${payment.last4}`}</p>
            <p className="card-holder hide-xs">{payment.holderName}</p>
            <p className="card-exp hide-xs">
              Expires {payment.expMonth}/{payment.expYear}
            </p>
          </div>

          <div className="d-flex align-items-center mw">
            {(payment.default && (
              <label className="label label-blue">Default</label>
            )) || <noscript />}
          </div>
        </div>
        <icon
          className="icon icon-trash"
          onClick={() => handleDeleteCard(payment.uid)}
        />
      </a>
    </li>
  )) || <noscript />;

export default ListItem;
